import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { ROUTES } from '~backoffice/app/~shared/constants/routes.constants';

@Component({
  selector: 'login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent extends BaseAuthComponent {
  title = this.isSandboxEnvironment
    ? 'Environnement Sandbox'
    : 'Portail Administrateur DGI';

  description =
    'Accédez à l’espace de supervision et de contrôle du système national de facturation électronique.';

  routes = ROUTES;
}
